'use client'
import { REVIEW_DEFAULT_VISIBLE_OPTIONS, ROOM_AMENITIES_PREVIEW_COUNT } from '@/src/constants/hotels'
import { ReviewRoomGroup } from '@/src/types/hotels/details'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import RoomGroupCard from './roomGroupCard'
import { ReviewContext } from '../roomVariantRow'

export interface RoomGroupCardContainerProps {
    group: ReviewRoomGroup
    variant: 'mobile' | 'desktop'
    reviewContext: ReviewContext
    onSelect: (rId: string, arNo: string) => void
}

// Logic layer: first N options show; the rest expand on demand. Resolves the room
// media / amenities labels (i18n) from the group's roomContent-derived fields.
const RoomGroupCardContainer = ({ group, variant, reviewContext, onSelect }: RoomGroupCardContainerProps) => {
    const t = useTranslations('hotels')
    const [expanded, setExpanded] = useState(false)

    const visibleOptions = expanded ? group.options : group.options.slice(0, REVIEW_DEFAULT_VISIBLE_OPTIONS)
    const hiddenCount = group.options.length - visibleOptions.length

    return (
        <RoomGroupCard
            group={group}
            variant={variant}
            visibleOptions={visibleOptions}
            hiddenCount={hiddenCount}
            moreLabel={t('moreOptions', { count: hiddenCount })}
            roomSizeLabel={group.roomSize != null ? t('roomSizeSqm', { size: group.roomSize }) : ''}
            // Labelled rather than a bare number: this is what the room sleeps, while the
            // itinerary summary shows the guests on the whole booking. Two rooms for four
            // guests made the unlabelled "2" here read as a contradiction of the "4" there.
            occupancyLabel={t('roomOccupancy', { count: group.occupancyAdults })}
            amenitiesPreviewCount={ROOM_AMENITIES_PREVIEW_COUNT}
            viewAllAmenitiesLabel={t('viewAllAmenities')}
            roomAmenitiesTitle={t('roomAmenities')}
            photosCountLabel={count => t('photosCount', { count })}
            reviewContext={reviewContext}
            onSelect={onSelect}
            onExpand={() => setExpanded(true)}
        />
    )
}

export { RoomGroupCardContainer }
export default RoomGroupCardContainer
